import { Meal } from '@akin-home/amplify';
import { mealGraphqlToModel } from '@akin-home/meals/frontend';
import { useMemo } from 'react';
import { UseQueryOptions } from 'react-query';
import { useGetMealQuery } from '.';

interface Props {
  id?: string;

  recurrence_id?: string;
}

/** Gets a single meal or recurrence instance if one is provided */
/** This is basically the same as the useGetEvent and useGetMeal hooks, so we should abstract some of this behaviour */
export const useGetMeal = ({ id }: Props, options?: UseQueryOptions) => {
  const { data, ...result } = useGetMealQuery({ id }, options);

  const meal = useMemo(
    () => (data ? mealGraphqlToModel(data as Meal) : undefined),
    [data]
  );

  return {
    item: meal,
    ...result,
  };
};
